<div
  class="messages-container"
  #scrollContainer
  (scroll)="onScroll()"
>
  <div class="messages-inner">
    @if (state.loadingMessages()) {
      <div class="loading-indicator">{{ translateService.getTranslation(4150) }}</div>
    }

    @for (group of messageGroups; track group.dateLabel) {
      <div class="date-separator">
        <span class="date-label">{{ group.dateLabel }}</span>
      </div>

      @for (msg of group.messages; track msg.id) {
        <div
          class="message-row"
          [class.own]="isOwnMessage(msg)"
          [class.other]="!isOwnMessage(msg)"
        >
          <div class="message-meta">
            @if (!isOwnMessage(msg)) {
              <span class="sender-name">{{ msg.userName }}</span>
            }
            <span class="message-time"> {{ group.dateLabel }} {{ formatTime(msg.sentAt) }} </span>
            @if (isOwnMessage(msg)) {
              <span class="sender-name you"
                >{{ msg.userName }} ({{ translateService.getTranslation(4162) }})</span
              >
            }
          </div>

          <div
            class="message-bubble"
            [class.deleted]="msg.deleted"
          >
            @if (msg.deleted) {
              <span class="deleted-text">{{ translateService.getTranslation(4147) }}</span>
            } @else {
              @for (att of msg.attachments; track att.id) {
                @if (isImage(att)) {
                  <div
                    class="attachment-image"
                    (click)="openLightbox.emit(att)"
                  >
                    <img
                      [src]="getAttachmentUrl(att)"
                      [alt]="att.fileName"
                      loading="lazy"
                      (load)="onMediaLoaded()"
                    />
                  </div>
                } @else if (isVideo(att)) {
                  <div class="attachment-video">
                    <video
                      controls
                      preload="metadata"
                      (loadedmetadata)="onMediaLoaded()"
                    >
                      <source
                        [src]="getAttachmentUrl(att)"
                        [type]="att.mimeType"
                      />
                    </video>
                  </div>
                } @else {
                  <a
                    class="attachment-file"
                    [href]="getAttachmentUrl(att)"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span class="material-symbols-outlined file-icon">description</span>
                    <div class="file-info">
                      <span class="file-name">{{ att.fileName }}</span>
                      <span class="file-size">{{ getFileSize(att.fileSize) }}</span>
                    </div>
                  </a>
                }
              }

              @if (msg.content) {
                @if (editingMessageId() === msg.id) {
                  <input
                    type="text"
                    class="inline-edit-input"
                    [ngModel]="editingText()"
                    (ngModelChange)="editingText.set($event)"
                    (keydown.enter)="onSaveInlineEdit()"
                    (keydown.escape)="cancelInlineEdit()"
                  />
                } @else {
                  <p class="message-text">{{ msg.content }}</p>
                }
              }

              @if (msg.edited && editingMessageId() !== msg.id) {
                <span class="edited-label">{{ translateService.getTranslation(4146) }}</span>
              }
            }
          </div>

          @if (isOwnMessage(msg) && !msg.deleted) {
            <div class="message-actions">
              @if (editingMessageId() === msg.id) {
                <button
                  class="action-btn save-edit"
                  (click)="onSaveInlineEdit()"
                >
                  {{ translateService.getTranslation(1721) }}
                </button>
              } @else if (confirmingDeleteId() === msg.id) {
                <button
                  class="action-btn confirm-delete"
                  (click)="onConfirmDelete(msg)"
                >
                  {{ translateService.getTranslation(1272) }}
                </button>
              } @else {
                <button
                  class="action-btn"
                  (click)="onEditClick(msg)"
                >
                  {{ translateService.getTranslation(1723) }}
                </button>
                <button
                  class="action-btn delete"
                  (click)="onDeleteClick(msg)"
                >
                  {{ translateService.getTranslation(47) }}
                </button>
              }
            </div>
          }
        </div>
      }
    }

    @if (state.typingUsersForChat().length > 0) {
      <div class="typing-indicator">
        @for (user of state.typingUsersForChat(); track user.userId) {
          <span>{{ user.userName }}</span>
        }
        <span>{{ translateService.getTranslation(4151) }}</span>
      </div>
    }
  </div>
</div>

@if (showScrollButton) {
  <button
    class="scroll-to-bottom-btn"
    (click)="scrollToBottom()"
  >
    <span class="material-symbols-outlined">keyboard_arrow_down</span>
  </button>
}
